import {v4 as uuidv4} from 'uuid';
import {InvenMyInfo} from '../../api/type.client';
import {InvenMyInfoResultVo} from '../../common/shared/api/nicolas/vo/inven/InvenMyInfoResultVo.interface';
import {createDisplayAd} from './DisplayAd';
import {createMyInfo} from './MyInfo';

export function createInvenMyInfo(
  invenMyInfoResult: InvenMyInfoResultVo
): InvenMyInfo {
  return {
    displayAd: invenMyInfoResult.display_ad
      ? createDisplayAd(invenMyInfoResult.display_ad)
      : undefined,
    id: uuidv4(),
    myInfo: createMyInfo(invenMyInfoResult.my_info),
  };
}
